import { useEffect, useState } from 'react'
import { isSwanAccountCountry } from '@clari/shared'
import { authApi } from '@/lib/auth-api'
import { useAuthStore } from '@/stores/authStore'

/**
 * Residence eligibility for opening a Swan account.
 *
 * Decided on a FRESH /auth/me — NOT the possibly-stale persisted store user,
 * which let a Portugal resident reach the form after a prior France session
 * (the store still held the FR user). We refresh /me on mount, then gate on the
 * single shared source (SWAN_ACCOUNT_COUNTRIES). `loading` is true until the
 * fresh user resolves so the caller never gates on stale data.
 */
export function useResidenceEligibility(): { loading: boolean; eligible: boolean } {
  const user = useAuthStore((s) => s.user)
  const setUser = useAuthStore((s) => s.setUser)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    let active = true
    authApi
      .me()
      .then((r) => {
        if (active) setUser(r.user)
      })
      .catch(() => undefined)
      .finally(() => {
        if (active) setLoading(false)
      })
    return () => {
      active = false
    }
  }, [setUser])

  return { loading, eligible: isSwanAccountCountry(user?.country_residence) }
}
